<template>
  <pt-sheet :title="title" :subtitle="description" class="fill-height">
    <w9-upload
      v-if="action === 'upload'"
      @w9saved="isW9Saved = true"
    ></w9-upload>
    <w9-table v-else-if="action === 'table'"></w9-table>
  </pt-sheet>
</template>

<script>
import W9Table from "@/views/account/w9/W9Table";
import W9Upload from "@/views/account/w9/W9Upload";
import { get } from "@/services/request";
import { w9API } from "@/services/api";
import PtSheet from "@/components/PtSheet.vue";

const optionTexts = {
  upload: {
    title: "Upload Your W-9",
    description: "Upload a PDF or Image file below."
  },
  table: {
    title: "Your W-9",
    description: "" //handled by property
  }
};

export default {
  name: "W9",
  props: {
    tableDescription: {
      type: String,
      default:
        "To add or update your W-9, click the Add W-9 button. When a new or updated W-9 is submitted, all of your connected customers will have access to the most current version of your W-9. To view a previously submitted W-9, click the download button on the corresponding row."
    },
    w9Required: {
      type: Boolean,
      default: false
    },
    initialNavigation: {
      type: String,
      required: false
    }
  },
  components: {
    PtSheet,
    W9Table,
    W9Upload
  },
  data: () => {
    return {
      action: null,
      w9s: [],
      isW9Editing: false,
      isW9Saved: false
    };
  },
  provide() {
    return {
      nav: {
        w9Table: () => this.nav("table"),
        w9Upload: () => this.nav("upload")
      }
    };
  },
  watch: {
    isW9Editing() {
      this.validate();
    },
    isW9Saved() {
      if (this.isW9Saved) this.$emit("new-w9-saved");
      this.validate();
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      get(w9API)
        .then(response => {
          if (response && response.data) {
            this.w9s = response.data;
            if (this.w9s.length) this.$emit("existing-w9");
            this.nav(this.w9s.length ? "table" : "upload");
          }
        })
        .catch(error => {
          console.error("Error loading W9s", error);
          this.nav.w9Upload();
        })
        .finally(() => {
          if (this.initialNavigation) {
            this.nav(this.initialNavigation);
          }
        });
    },
    nav(location) {
      this.action = location;
    },
    validate() {
      this.$emit("form-valid", this.isFormValid);
      this.$emit(
        "form-error-message",
        !this.isW9Editing
          ? "Please submit a W9"
          : "Please save your changes or cancel out of them"
      );
    }
  },
  computed: {
    title() {
      return this.action ? optionTexts[this.action].title : "";
    },
    description() {
      return this.action
        ? this.action === "table"
          ? this.tableDescription
          : optionTexts[this.action].description
        : "";
    },
    isFormValid() {
      return (
        !this.isW9Editing &&
        (this.isW9Saved || this.w9s.length || !this.w9Required)
      );
    }
  }
};
</script>
